var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 5H12V14.5C12 15.3284 11.3284 16 10.5 16H1.5C0.671562 16 0 15.3281 0 14.5V1.5C0 0.671562 0.671562 0 1.5 0H7L7.00012 4C7 4.55312 7.44688 5 8 5ZM12 4H8V0L12 4ZM6.75 10.4406L7.96875 9.21875C8.2625 8.92813 8.73734 8.92562 9.03031 9.21875C9.32328 9.51188 9.32328 9.98641 9.03031 10.2794L6.53031 12.7794C6.23719 13.0723 5.76266 13.0723 5.46969 12.7794L2.96969 10.2794C2.67672 9.98625 2.67672 9.51172 2.96969 9.21875C3.11625 9.07187 3.30625 9 3.5 9C3.69375 9 3.88437 9.07187 4.00313 9.21875L5.25 10.4406V7.25C5.25 6.8375 5.58594 6.5 6 6.5C6.41406 6.5 6.75 6.83594 6.75 7.25V10.4406Z",
  fill: "#848484"
});

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.16ff3c5e19ab583ab3986a5c6d81fb08.svg";
export { ForwardRef as ReactComponent };